import { render, staticRenderFns } from "./Ers.vue?vue&type=template&id=37dd1963&"
import script from "./Ers.vue?vue&type=script&lang=js&"
export * from "./Ers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports